import { render, staticRenderFns } from "./UniversalModal.vue?vue&type=template&id=a39ec042&"
import script from "./UniversalModal.vue?vue&type=script&lang=js&"
export * from "./UniversalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports